import { FC } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/system';

import { Spinner } from 'src/components/spinner';
import { routes } from 'src/constants/routes';

import { styles } from './styles';
import { useProcessBrochureCallback } from './hooks/use-process-brochure-callback';

export const BrochureCallbackPage: FC = () => {
    const { isError, isPending } = useProcessBrochureCallback();
    const [searchParams] = useSearchParams();

    if (isPending)
        return (
            <Box css={styles.wrapper}>
                <Spinner size="big" />
            </Box>
        );

    if (isError) {
        return <Navigate to={routes.failure.index} />;
    }

    return (
        <Navigate
            to={{
                pathname: routes.yourDetails.index,
                search: searchParams.toString(),
            }}
        />
    );
};
